import React from 'react';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';

import { decorateComponent } from '../../../documentComponents';
import { AccordionContent } from './AccordionContent';

export default decorateComponent(AccordionContent, 'block', {
  id: 'accordionContent',
  label: '아코디언 내용',
  allowedParent: ['accordion'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: () => <BsCardText />,
});
